import "moment/locale/it"
import { Col, Row } from "react-bootstrap"
import { statNumberToString } from "../../../../apis/transform/stats"
import style from "./style.module.scss"
import cx from "classnames"

export function PlayerBalls({ lostBalls, retrievedBalls }: { lostBalls: number; retrievedBalls: number }) {
  return (
    <div className={style.playerBallsContainer}>
      <Row className={cx(style.playerBallsRow, style.whiteBg)}>
        <dl>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.label}>
            <dt>Palle perse</dt>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.value}>
            <dd>{statNumberToString(lostBalls)}</dd>
          </Col>
        </dl>
      </Row>
      <Row className={style.playerBallsRow}>
        <dl>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.label}>
            <dt>Palle recuperate</dt>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.value}>
            <dd>{statNumberToString(retrievedBalls)}</dd>
          </Col>
        </dl>
      </Row>
    </div>
  )
}
